// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2YsFC","modal":"Modal_modal__4DXUe","fadeIn":"Modal_fadeIn__1i-xJ","buttons":"Modal_buttons__1tQXU","cancel":"Modal_cancel__1-5J1"};